const docMissingEmployeeStatus = {
  text: 'EMPLEADO BLOQUEADO MANUALMENTE'
};

export default docMissingEmployeeStatus;
